"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMenuItemsMutationOptions = exports.createMenuItemsMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const menuPlanner_1 = require("../queries/menuPlanner");
exports.createMenuItemsMutation = client_1.gql `
  mutation CreateMenuItems($menuItems: [MenuItemInput!]!) {
    createMenuItems(menuItems: $menuItems) {
      ok
      errors {
        path
        message
      }
      menuItems {
        id
      }
    }
  }
`;
exports.createMenuItemsMutationOptions = (variables, recipes, menuPlannerQueryVariables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        createMenuItems: {
            errors: null,
            ok: true,
            __typename: "MenuItemsResponse",
            menuItems: recipes.map((_, i) => ({
                id: `${-(i + 1)}`,
                __typename: "MenuItem",
            })),
        },
    },
    update: !menuPlannerQueryVariables
        ? undefined
        : (store, { data: dataResponse }) => {
            if (!dataResponse) {
                return;
            }
            const { createMenuItems: { errors, menuItems: mis }, } = dataResponse;
            if (errors || !mis || !mis.length) {
                return;
            }
            updateQuery_1.updateQuery(store, menuPlanner_1.menuPlannerQuery, x => {
                x.menuPlanner.push(...mis.map((mi, i) => {
                    return Object.assign(Object.assign({ __typename: "MenuItem" }, variables.menuItems[i]), { scale: 1, id: mi.id, recipe: Object.assign(Object.assign({}, recipes[i]), { __typename: "Recipe" }) });
                }));
            }, menuPlannerQueryVariables);
        },
});
//# sourceMappingURL=createMenuItem.js.map